const progessLesson = {
    namespaced : true,
    state : {
        loading: false
    },
    mutations : {
        setLoading(state, payload) {
            state.loading = payload;
        }
    },
    getters : {
        getLoading (state) {
            return state.loading;
        }
    }
};

export default progessLesson;


// WEBPACK FOOTER //
// ./src/stores/modules/progessLesson.js